import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * This file is redundant, as all the states are already captured
 * in services/user-profile.ts
 *
 * But this is kept here because there are a lot of existing logic
 * that relies on userProfile coming from redux state under 'userProfile'
 */
interface UserProfile {
  access: string | false;
  joinDate: number | false;
  firstName: string | false;
  lastName: string | false;
  hasSelectedProfile: boolean;
  jobTitle: string | false;
  organization: string | false;
  role: string[] | false;
  orgId: string;
}

interface EditProfile {
  firstName: string;
  lastName: string;
  jobTitle: string;
}

interface State {
  readonly onlyOneOrg?: boolean;
  readonly access?: string;
  readonly joinDate?: number;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly hasSelectedProfile: boolean;
  readonly jobTitle?: string;
  readonly organization?: string;
  readonly role?: string[];
  readonly orgId?: string;
}

const initialState: State = {
  onlyOneOrg: false,
  hasSelectedProfile: false,
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    receiveSignedInUserProfile: (
      state,
      { payload }: PayloadAction<UserProfile | undefined>
    ) => {
      state.access = payload?.access ? payload.access : undefined;
      state.joinDate = payload?.joinDate ? payload.joinDate : undefined;
      state.firstName = payload?.firstName ? payload.firstName : undefined;
      state.lastName = payload?.lastName ? payload.lastName : undefined;
      state.hasSelectedProfile = !!payload?.hasSelectedProfile;
      state.jobTitle = payload?.jobTitle ? payload.jobTitle : undefined;
      state.organization = payload?.organization
        ? payload.organization
        : undefined;
      state.role = payload?.role ? payload.role : undefined;
      state.orgId = payload?.orgId ? payload.orgId : undefined;
    },
    editProfile: (state, { payload }: PayloadAction<EditProfile>) => {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.jobTitle = payload.jobTitle;
    },
  },
});
